import React from "react";

function IndustryGrowth() {
  return (
    <div className="about-area pt-5 pb-5">
      <div className="container">
        <div className="row align-items-center flex-column-reverse flex-lg-row">
          <div className="col-lg-6">
            <div className=" pe-lg-5">
              <h2
                className="title split-lines mb-4"
                style={{ fontWeight: "bold" }}
              >
                DeFi Industry Growth in 2024
              </h2>
              <p style={{ fontSize: "16px", color: "#555", lineHeight: "1.8" }}>
                The DeFi market has seen unprecedented exponential traction over
                the recent quarters, with immense institutional capital
                aggressively pivoting towards transparent yield mechanisms. In
                2024, Total Value Locked (TVL) has systematically shattered
                historic milestones, driven predominantly by massive integration
                of Real World Assets (RWAs) and institutional liquidity
                provisioning frameworks.
              </p>
              <p
                className="mt-3"
                style={{ fontSize: "16px", color: "#555", lineHeight: "1.8" }}
              >
                Future projections consistently confirm immense trillion-dollar
                valuation shifts. Web3 networks scale rapidly handling
                hyper-fractional trades affordably, fueling widespread retail
                adoption and fortifying incredibly robust, decentralized smart
                economies exactly customized for the digital age scaling.
              </p>
            </div>
          </div>
          <div className="col-lg-6 text-center mb-4 mb-lg-0">
            <div className="thumb">
              <img
                src="/assets/img/illustration/3.png" // placeholder
                alt="DeFi Industry Growth"
                style={{ maxWidth: "80%" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IndustryGrowth;
